import { CustomDomainsPanel } from '../../features/custom-domains';
import { useOrganizationSettings } from './use-organization-settings';
import { SettingsShell } from './settings-shell';

export const DomainsPage = () => {
  const { timeZone } = useOrganizationSettings();

  return (
    <SettingsShell
      active="/settings/domains"
      question="Where senders deliver webhooks: your own hostname, or ours."
    >
      <CustomDomainsPanel timeZone={timeZone} />
    </SettingsShell>
  );
};
